import { resolveTaxRateFromDeals, type Kitchen } from '@rta/rta-blueprint-library';

import type { State as CustomerState } from '../state-management/customer/state.type';
import type { Project } from '../state-management/project/types/project.type';

export type EstimatedTaxResult = {
	tax: number;
	taxRate: number;
	taxNote?: string;
	zipcode: string;
	state: string;
};

export type GetEstimatedTaxParams = {
	kitchen: Kitchen;
	customer: CustomerState;
	project: Array<Project>;
	dealId?: string;
};

export const getEstimatedTax = (params: GetEstimatedTaxParams): EstimatedTaxResult => {
	const { kitchen, customer, project, dealId } = params;
	const { itemizedMsrp } = kitchen;

	// Callers in flows that don't persist the selection onto the kitchen (e.g. the presentation
	// generation modal) pass `dealId` explicitly; otherwise fall back to the kitchen's associated deal.
	const effectiveDealId = dealId || kitchen.dealId;
	const { taxRate, taxState: state, zip: zipcode } = resolveTaxRateFromDeals({
		deals: project.map((d) => ({ dealId: d.dealId, zip: d.zip, state: d.state })),
		preferredDealId: effectiveDealId,
		fallbackZip: customer.zipcode,
		fallbackState: customer.state
	});
	const tax = Math.round(itemizedMsrp.subtotal * taxRate * 100) / 100;

	const taxNote = (() => {
		if (tax !== 0) return undefined;
		if (!effectiveDealId) return 'No deal associated';
		if (!zipcode) return 'Missing zip code on deal';
		return undefined;
	})();

	return { tax, taxRate, taxNote, zipcode, state };
};
